export default {
	dealers: null,
};
